<template lang="pug">
#navbar-container(v-cloak)
  .navbar-left-container
    router-link(to="/")
      img.logo(src="../assets/images/navbar/brick-magic-logo.png")
  .navbar-right-container
    router-link.nav-item.login-button(to="/login", v-if="!$store.state.isLoggedIn")
      img(src="../assets/images/icons/lego-skull.png")
      span.login-text Login / #[br] Register
    router-link.nav-item.login-button(to="/dashboard/profile", v-if="$store.state.isLoggedIn")
      img(src="../assets/images/icons/lego-yellow.png")
      span.login-text My #[br] Account

    router-link.nav-item(to="/favourites")
      img(src="../assets/images/icons/favourite-red.png")
    router-link.nav-item.cart(to="/cart", :class="{ hovering: isHovering }")
      img(@mouseover="isHovering = true", @mouseleave="isHovering = false", src="../assets/images/icons/cart.png")
      .cart-item-number {{ $store.state.cart.items ? $store.state.cart.items.length : 0 }}
    .cartdropdown-container
      CartDropdown(:onHover="true")
</template>

<script>
export default {
  props: ['numberOfCartItem', 'onHover'],
  data () {
    return {
      isHovering: false
    }
  },
  components: {
    CartDropdown: () => import('./cart-dropdown.vue')
  }
}
</script>

<style lang="sass">
@import '../sass/variables'

#navbar-container
  display: flex
  align-items: center
  padding: 0 60px
  +mobile
    padding: 0 10px 0 0

  .navbar-left-container
    flex-grow: 1
    padding: 20px
    .logo
      width: 160px

  .navbar-right-container
    .nav-item
      margin-right: 19px
      +mobile
        margin-right: 5px
      &:nth-child(3)
        margin-right: 13px
        +mobile
          margin-right: 5px
    .login-button
      display: inline-flex
      align-items: center
      .login-text
        display: inline-block
        font-weight: 500
        font-size: 14px
        line-height: 16px
        margin-left: 5px
        +mobile
          font-size: 10px
          line-height: 11px

    .cart
      position: relative
      display: inline-block
      .cart-item-number
        position: absolute
        color: white
        font-weight: 900
        font-size: 12px
        font-family: 'Open Sans', sans-serif
        text-align: center
        bottom: 3px
        left: -1px
        padding: 2px 6px
        border-radius: 50%
        background-color: #E3000B
        pointer-events: none

  .cartdropdown-container
    width: 400px
    height: 120vh
    position: absolute
    top: 85px
    right: 50px
    background-color: transparent
    z-index: 3
    overflow: hidden
    pointer-events: none

  .nav-item.cart
    #cart-dropdown.hover
      transition-delay: 0.3s
    &.hovering
      + .cartdropdown-container
        +desktop
          width: 400px
          height: 100vh
          position: absolute
          top: 85px
          right: 50px
          background-color: transparent
          z-index: 3
          overflow: hidden
        #cart-dropdown.hover
          +desktop
            display: initial
            position: absolute
            transform: translateY(calc(1px + 12px))
            transition: all 0.5s
            transition-delay: 0.3s
  #cart-dropdown
    z-index: 100
    pointer-events: all
    &:hover
      +desktop
        display: initial
        position: absolute
        transform: translateY(calc(1px + 12px))
        transition: all 0.2s
</style>
